module.exports = __webpack_public_path__ + "static/media/iphone.93bf868b.png";